import { render, staticRenderFns } from "./VMap.vue?vue&type=template&id=0c936b47&"
import script from "./VMap.vue?vue&type=script&lang=js&"
export * from "./VMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports